export default {
  lime: {
    50: "#FDFFE6",
    100: "#EDFFC3",
    200: "#E1FF9D",
    300: "#CDEF89",
    400: "#B9DB75",
    500: "#A5C761",
    600: "#91B34D",
    700: "#7D9F39",
    800: "#5F811B",
    900: "#416300",
  },
  prussian: {
    50: "#83B1C9",
    100: "#47758D",
    200: "#336179",
    300: "#1F4D65",
    400: "#15435B",
    500: "#012F47",
    600: "#00253D",
    700: "#001B33",
    800: "#001129",
    900: "#00071F",
  },
  teal: {
    50: "#7EC1C1",
    100: "#60A3A3",
    200: "#4C8F8F",
    300: "#428585",
    400: "#2E7171",
    500: "#246767",
    600: "#105353",
    700: "#064949",
    800: "#003535",
    900: "#002B2B",
  },
  pink: {
    50: "#FFF7FF",
    100: "#FFD9FF",
    200: "#FFC5FF",
    300: "#FFB1F7",
    400: "#FF93D9",
    500: "#FF75BB",
    600: "#EB61A7",
    700: "#D74D93",
    800: "#C3397F",
    900: "#AF256B",
  },

  purple: {
    50: "#FAE0FE",
    100: "#F2BFF9",
    200: "#E89EF2",
    300: "#DB80E8",
    400: "#CE63DD",
    500: "#C14BD1",
    600: "#B336C5",
    700: "#A422B6",
    800: "#9A0BAE",
    900: "#820394",
  },
  orange: {
    50: "#FFFCE5",
    100: "#FFF3C9",
    200: "#FFEDAB",
    300: "#FFE397",
    400: "#FFB179",
    500: "#FF9347",
    600: "#E47529",
    700: "#D06115",
    800: "#BC4D14",
    900: "#A83900",
  },
  yellow: {
    50: "#FFFFE5",
    100: "#FFFFD9",
    200: "#FFFFBF",
    300: "#FFFF99",
    400: "#FFFF80",
    500: "#FFF173",
    600: "#E5D860",
    700: "#D7C94E",
    800: "#B9AB30",
    900: "#7D6F00",
  },
  blue: {
    50: "#f3faff",
    100: "#e6f6ff",
    200: "#c1e8ff",
    300: "#9cdbff",
    400: "#51bfff",
    500: "#07A4FF",
    600: "#0694e6",
    700: "#057bbf",
    800: "#046299",
    900: "#03507d",
  },
  green: {
    50: "#f4fdf9",
    100: "#e8fbf3",
    200: "#c6f5e0",
    300: "#a3efce",
    400: "#5ee2a9",
    500: "#19D684",
    600: "#17c177",
    700: "#13a163",
    800: "#0f804f",
    900: "#0c6941",
  },
  red: {
    50: "#fff7f7",
    100: "#fef0f0",
    200: "#fdd9d9",
    300: "#fbc1c1",
    400: "#f89393",
    500: "#F56565",
    600: "#dd5b5b",
    700: "#b84c4c",
    800: "#933d3d",
    900: "#783131",
  },
  steel: {
    50: "#f5f5f6",
    100: "#eaebed",
    200: "#cbcdd1",
    300: "#abafb6",
    400: "#6c737f",
    500: "#2D3748",
    600: "#293241",
    700: "#222936",
    800: "#1b212b",
    900: "#161b23",
  },
  graphite: {
    50: "#f4f4f5",
    100: "#e9eaeb",
    200: "#c7cacd",
    300: "#a6aaaf",
    400: "#636a73",
    500: "#202A37",
    600: "#1d2632",
    700: "#182029",
    800: "#131921",
    900: "#10151b",
  },
  carbon: {
    50: "#f3f4f4",
    100: "#e8e9e9",
    200: "#c5c7c9",
    300: "#a2a5a9",
    400: "#5d6268",
    500: "#171E27",
    600: "#151b23",
    700: "#11171d",
    800: "#0e1217",
    900: "#0b0f13",
  },
};
